/**
 * Get the appropriate API base URL based on the current environment
 * @returns {string} The API base URL
 */
export const getApiBaseUrl = () => {
    // Check for environment variable override first
    if (process.env.REACT_APP_API_URL) {
        console.log('🔄 Using API URL from environment variable:', process.env.REACT_APP_API_URL);
        return process.env.REACT_APP_API_URL;
    }

    // TEMPORARY: Uncomment the line below to force production API usage locally
    // return 'https://api.interstellarmap.com';

    // In development (localhost), use the local proxy
    if (window.location.hostname === 'localhost') {
        console.log('🏠 Using local API proxy:', '/api');
        return '/api';
    }

    // In production, use the API subdomain
    console.log('🌐 Using production API:', 'https://api.interstellarmap.com');
    return 'https://api.interstellarmap.com';
};

/**
 * Build a complete API URL for the given endpoint
 * @param {string} endpoint - The API endpoint (without leading slash)
 * @returns {string} Complete API URL
 */
export const buildApiUrl = (endpoint) => {
    const baseUrl = getApiBaseUrl();
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${baseUrl}/${cleanEndpoint}`;
}; 